/* ============================================================
   LIVRARIA — Motor de animação premium
   • Revelação no scroll (fade + sobe + desfoque→nítido)
   • Contadores que "contam" (count-up) ao entrar em vista
   • Ken-burns em .premium-figure
   Sem dependências. Respeita prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  // ---- Count-up ----
  function animateCount(el) {
    if (el._counted) return;
    el._counted = true;
    var raw = el.getAttribute('data-count-text') || el.textContent;
    el.setAttribute('data-count-text', raw);

    var m = raw.match(/^(\D*)(-?[\d.,]+)([\s\S]*)$/);
    if (!m) return;
    var prefix = m[1];
    var numStr = m[2];
    var suffix = m[3];
    var decimals = numStr.indexOf('.') >= 0 ? (numStr.split('.')[1] || '').length : 0;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;

    if (reduceMotion) { el.textContent = raw; return; }

    var dur = 1600;
    var startTs = null;
    function step(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min((ts - startTs) / dur, 1);
      var val = target * easeOutCubic(p);
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = raw;
      }
    }
    el.textContent = prefix + (0).toFixed(decimals) + suffix;
    requestAnimationFrame(step);
  }

  function activate(el) {
    el.classList.add('is-visible');
    if (el.hasAttribute && el.hasAttribute('data-count')) animateCount(el);
    if (el.querySelectorAll) {
      el.querySelectorAll('[data-count]').forEach(animateCount);
    }
  }

  var selector = '[data-reveal], .premium-figure, [data-count]';
  var targets = document.querySelectorAll(selector);

  if (reduceMotion || !('IntersectionObserver' in window)) {
    targets.forEach(activate);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        activate(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach(function (el) { observer.observe(el); });

  // Reaplica em conteúdo carregado pelo editor de tema
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll(selector).forEach(function (el) { observer.observe(el); });
  });
})();

/* ============================================================
   LIVRARIA — Descrição "Ler mais" (line-clamp)
   ============================================================ */
(function () {
  'use strict';

  function refreshRmt(el) {
    var content = el.querySelector('.rmt__content');
    var btn = el.querySelector('.rmt__toggle');
    if (!content || !btn || el.classList.contains('is-open')) return;

    var maxHeight = parseFloat(window.getComputedStyle(content).maxHeight);
    if (!Number.isFinite(maxHeight) || maxHeight <= 0) return;

    var isTruncated = content.scrollHeight - maxHeight > 4;
    el.classList.toggle('is-truncated', isTruncated);
    btn.hidden = !isTruncated;
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = btn.getAttribute('data-more') || 'Ler mais';
  }

  function initRmt(scope) {
    (scope || document).querySelectorAll('[data-rmt]').forEach(function (el) {
      if (el._rmtInit) return;
      el._rmtInit = true;
      var content = el.querySelector('.rmt__content');
      var btn = el.querySelector('.rmt__toggle');
      if (!content || !btn) return;

      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open
          ? (btn.getAttribute('data-less') || 'Ocultar')
          : (btn.getAttribute('data-more') || 'Ler mais');

        if (!open) refreshRmt(el);
      });

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { refreshRmt(el); });
      });

      window.addEventListener('load', function () { refreshRmt(el); }, { once: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { refreshRmt(el); });
      }

      if ('ResizeObserver' in window) {
        el._rmtObserver = new ResizeObserver(function () { refreshRmt(el); });
        el._rmtObserver.observe(content);
      }
    });
  }
  if (document.readyState !== 'loading') initRmt();
  else document.addEventListener('DOMContentLoaded', function () { initRmt(); });
  document.addEventListener('shopify:section:load', function (e) { initRmt(e.target); });
})();
